import React from 'react';
import Table from '../../components/common/Table';
import { ClientDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface ClientTableProps {
  data: ClientDTO[];
  handleEdit: (row: ClientDTO) => void;
  handleDelete: (row: ClientDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ClientTable: React.FC<ClientTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Name',
          key: 'name',
        },
        {
          label: 'Contact Person',
          key: 'contactPersonName',
          render: (row: ClientDTO) => {
            return (
              <span>
                {row.contactPersonName}
              </span>
            );
          }
        },

        {
          label: 'Email',
          key: 'contactPersonEmail',
        },
        {
          label: 'Phone',
          key: 'contactPersonPhone',
        },
        {
          label: 'Hourly Rate',
          key: 'defaultHourlyRate',
          format: (value: number) => `R ${value.toFixed(2)}`,
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ClientTable;
